<template>
  <v-tabs color="nx-primary--darken-2">
    <v-tab :to="route('board.editor')">
      {{ $t('message.board.breadcrumbs.edition') }}
    </v-tab>
    <v-tab :to="route('board.metadata')">
      {{ $t('message.board.breadcrumbs.metadata') }}
    </v-tab>

    <v-tab :to="route('board.dayparting')">
      {{ $t('message.board.breadcrumbs.daypartingBlocksList') }}
    </v-tab>

    <v-tab
      :to="{ name: 'board.dayparting', params: {id: blockId}, query: {refBoard: refBoardId}, exact: true }">
      {{ $t('message.board.breadcrumbs.daypartingBlockEdition') }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  props: {
    refBoardId: Number,
    blockId: Number,
  },
  methods: {
    route(n) {
      return {
        name: n,
        params: { id: this.refBoardId },
        exact: true,
      };
    },
  },
};
</script>
